import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import { AgmMap } from "@agm/core";
import { Router } from "@angular/router";
import { GlobalFunction } from "../../routes/services/globalFuntion";
import { gateway, transparent, waterwise_icons } from "../../routes/services/icons";
import { Scope } from "../../routes/Admin/organization/interfaces/scope.interface";
import { colors } from "../../routes/Clients/device/constants";

@Component({
  selector: "app-map-dynamic",
  templateUrl: "./map.html",
  styleUrls: ["./map.scss"]
})
export class MapaComponent implements OnInit, OnDestroy {
  @ViewChild(AgmMap) map: any;
  @Output() clickFeederMap = new EventEmitter();
  @Output() clickMap = new EventEmitter();
  @Output() clickMapPolygon = new EventEmitter();
  @Output() clickFeederActionAlert = new EventEmitter();
  @Output() clickFeederActionSensor = new EventEmitter();
  @Output() dragMarkerCoordinates = new EventEmitter();
  colors = colors;
  @Input() map_scope: Scope;
  show_info_scope = false;
  pond_selected;
  /* Granja con coordenadas */
  @Input() farm: null | any = null;
  /* Granjas con coordenadas */
  @Input() farms: null | any = null;
  /* Estanques con alimentadores */
  @Input() list_polygon_with_feeders: null | any = null;
  /* Solo coordenadas de estanque */
  @Input() ponds_coordinates: null | any = null;
  /* Solo alimentadores */
  @Input() feeders: null | any = null;

  @Input() feeders_ordering: null | any[] = null;

  @Input() marker_coordinates: null | any = null;

  @Input() marker_coordinates_draggable = false;

  @Input() feeders_gateway: null | any = null;

  @Input() default_color = "";

  @Input() type_info_window:
    | "feeder"
    | "sensors"
    | "gateway"
    | "waterwise"
    | "waterwise_ordering"
    | "feeder_alerts"
    | "feeder_sweep"
    | "ration_sweep"
    | "feeder_ordering"
    | "feeders_gateway"
    | "dashboard_farm"
    | "dashboard_pond" = "feeder";

  /* Ajusta el zoom del mapa para que todos los poligonos queden visibles */
  @Input() fit_bounds = false;

  /* Limites usados solo para el encuadre inicial, independientes de la restriccion de paneo */
  fit_bounds_value: any = null;

  /* Mapa nativo de Google entregado por mapReady: map lo pisa el ViewChild con el AgmMap */
  google_map: any = null;

  /* Granja o estanque cuyo tooltip del dashboard debe mostrarse abierto */
  @Input() dashboard_selected: any = null;
  @Output() clickDashboardAlerts = new EventEmitter();
  @Output() clickDashboardNavigate = new EventEmitter();
  @Output() clickDashboardOpen = new EventEmitter();
  @Output() closeDashboardInfoWindow = new EventEmitter();
  @Input() marker = {
    lat: 0,
    lng: 0
  };

  @Input() mode: "" | "simple" | "complete" = "";
  @Input() height = "100%";
  @Input() width = "100%";
  @Input() view_markers = true;
  @Input() view_marker_waterwise = true;

  @Input() restriction = true;

  @Input() go_view_map: null | { lat: number; lng: number } = null;

  @Input() icon_marker: "" | "gateway" | "waterwise" = "";
  @Input() list_waterwise = [];

  transparent = transparent;

  lat = 25.8284395;
  lng = -108.9410592;
  @Input() zoom: number = 15;

  validateIcons = false;
  mapRestriction: any = null;
  default_marker_icon = {
    url:
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'%3E%3Cdefs%3E%3Cfilter id='shadow' x='-50%25' y='-50%25' width='200%25' height='200%25'%3E%3CfeDropShadow dx='0' dy='1' stdDeviation='1.2' flood-color='%23000000' flood-opacity='0.3'/%3E%3C/filter%3E%3C/defs%3E%3Ccircle cx='9' cy='9' r='6' fill='%23ff0000' stroke='%23ffffff' stroke-width='3' filter='url(%23shadow)'/%3E%3C/svg%3E",
    scaledSize: {
      width: 18,
      height: 18
    },
    anchor: {
      x: 9,
      y: 9
    }
  };

  constructor(public Router: Router, public globalFunction: GlobalFunction) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["go_view_map"] && changes["go_view_map"].currentValue) {
      const { lat, lng } = changes["go_view_map"].currentValue;
      this.lat = Number(lat);
      this.lng = Number(lng);
      this.zoom = 15;
    }
    if (changes["farm"] && changes["farm"].currentValue) {
      this.set_restriccion(changes["farm"].currentValue.coordinates);
    }
    if (changes["ponds_coordinates"] && changes["ponds_coordinates"].currentValue.length > 0) {
      this.set_restriccion(changes["ponds_coordinates"].currentValue);
    }
    if (changes["map_scope"] && changes["map_scope"].currentValue) {
      this.set_restriccion(changes["map_scope"].currentValue.farm.coordinates);
    }
    /* Los poligonos pueden llegar despues del render inicial: reencuadramos al recibirlos */
    if (this.fit_bounds && changes["list_polygon_with_feeders"]) {
      this.set_fit_bounds(this.collect_coordinates());
    }
  }

  ngOnInit(): void {
    if (this.fit_bounds) {
      this.set_fit_bounds(this.collect_coordinates());
    }
    if (this.restriction) {
      if (this.ponds_coordinates) {
        this.set_restriccion(this.ponds_coordinates);
      } else if (this.farm) {
        this.set_restriccion(this.farm.coordinates);
      } else if (this.list_polygon_with_feeders) {
        if (this.list_polygon_with_feeders.length === 1) {
          this.set_restriccion(this.list_polygon_with_feeders[0].coordinates);
        } else {
          let feeders: any = [];
          this.list_polygon_with_feeders.forEach((item) => {
            feeders = [...feeders, ...item.coordinates];
          });
          if (feeders.length > 0) {
            this.mapRestriction = {
              latLngBounds: this.globalFunction.getMapBounds(feeders),
              strictBounds: false
            };
          }
        }
      } else if (this.marker_coordinates) {
        this.set_restriccion(this.marker_coordinates);
      } else {
      }
    } else {
      if (this.farm) {
        if (this.farm.coordinates && this.farm.coordinates.length > 0) {
          const { lat, lng } = this.globalFunction.centerPolygon(this.farm.coordinates);
          this.lat = lat;
          this.lng = lng;
          this.zoom = 15;
        }
      }
      this.mapRestriction = null;
    }
  }
  /**
   * Reune las coordenadas de los poligonos dibujados para calcular el encuadre inicial.
   * @returns Arreglo de coordenadas de todos los poligonos visibles.
   */
  collect_coordinates(): any[] {
    if (this.farm && this.farm.coordinates && this.farm.coordinates.length > 0) {
      return this.farm.coordinates;
    }
    if (this.list_polygon_with_feeders && this.list_polygon_with_feeders.length > 0) {
      let coordinates: any[] = [];
      this.list_polygon_with_feeders.forEach((item) => {
        coordinates = [...coordinates, ...(item.coordinates || [])];
      });
      return coordinates;
    }
    if (this.ponds_coordinates) {
      return this.ponds_coordinates;
    }
    return [];
  }

  /**
   * Guarda los limites del encuadre inicial y reactiva el ajuste del mapa.
   * @param coordinates Coordenadas a encuadrar.
   * @returns void
   */
  set_fit_bounds(coordinates: any[]): void {
    if (!coordinates || coordinates.length === 0) {
      return;
    }
    this.fit_bounds_value = this.globalFunction.getMapBounds(coordinates);
    this.apply_fit_bounds();
  }

  set_restriccion = (coordinates) => {
    this.set_fit_bounds(coordinates);
    this.mapRestriction = {
      latLngBounds: this.globalFunction.getMapBounds(coordinates),
      strictBounds: false
    };
    if (coordinates && coordinates.length > 0) {
      const { lat, lng } = this.globalFunction.centerPolygon(coordinates);
      this.lat = lat;
      this.lng = lng;
    }
    this.zoom = this.zoom;
  };

  onMapReady(map) {
    this.map = map;
    this.google_map = map;
    this.apply_fit_bounds();
  }

  /**
   * Indica si el mapa dibuja los tooltips del dashboard de granjas/estanques.
   * @returns true cuando el tipo de info window es de dashboard.
   */
  isDashboardTooltip(): boolean {
    return this.type_info_window === "dashboard_farm" || this.type_info_window === "dashboard_pond";
  }

  /**
   * Click en el marcador central del poligono. En los tooltips del dashboard emite el item
   * para poder abrirlo; en el resto conserva el comportamiento previo.
   * @param event Evento emitido por el marcador de AGM.
   * @param item Poligono asociado al marcador.
   * @returns void
   */
  clickMarkerPolygon(event, item): void {
    if (this.isDashboardTooltip()) {
      this.clickMapPolygon.emit({ event, value: item });
      return;
    }
    /* Comportamiento previo del marcador: emitia el item como event */
    this.clickMapPolygon.emit({ event: item, value: undefined });
  }

  /**
   * Avisa al padre que el tooltip del dashboard se cerro para limpiar la seleccion.
   * @param item Granja o estanque cuyo tooltip se cerro.
   * @returns void
   */
  onDashboardInfoWindowClose(item): void {
    this.closeDashboardInfoWindow.emit(item);
  }

  /**
   * Devuelve el icono del encabezado del tooltip del dashboard segun el tipo de poligono.
   * @returns Ruta del icono de granja o de estanque.
   */
  getDashboardIcon(): string {
    return this.type_info_window === "dashboard_farm"
      ? "menu-icons/farm.svg"
      : "custom_icons/ponds.svg";
  }

  /**
   * Encuadra el mapa en los limites calculados. Se aplica una sola vez por cambio de datos
   * para no bloquear el paneo del usuario ni el reposicionamiento de los tooltips.
   * @returns void
   */
  apply_fit_bounds(): void {
    if (!this.fit_bounds || !this.fit_bounds_value || !this.google_map) {
      return;
    }
    /* Padding menor al de Google para que los poligonos no queden tan chicos */
    this.google_map.fitBounds(this.fit_bounds_value, 20);
  }

  /**
   * Libera las referencias al mapa de Google al destruir el componente.
   * AgmMap ya limpia sus propios listeners, aqui solo se sueltan las
   * referencias para que el recolector de basura pueda liberar la instancia.
   * @returns void
   */
  ngOnDestroy(): void {
    this.map = null;
    this.pond_selected = null;
    this.mapRestriction = null;
  }
  changeZoom(zoom) {
    this.validateIcons = zoom >= 17;
  }

  validateColor(item, type) {
    const verde = "#4caf50";
    const gris = "#9b9b9b";
    const rojo = "#FF0000";
    const azul = "#204349";
    const is_simple = this.mode === "simple";

    if (this.type_info_window === "dashboard_farm" || this.type_info_window === "dashboard_pond") {
      /* El color ya viene precalculado desde el componente padre segun el ratio de salud. */
      return (item && item.map_color) || gris;
    }

    if (this.type_info_window === "ration_sweep") {
      /* Barrido de alimentacion: gris pendiente/ignorado, teal en proceso, verde finalizado, rojo error. */
      if (!item || item.ignore) {
        return gris;
      }
      if (item.sweep_status === "failed") {
        return rojo;
      }
      if (item.sweep_status === "loading") {
        return "#30646c";
      }
      return item.sweep_status === "success" ? verde : gris;
    }

    if (this.type_info_window === "feeder_sweep") {
      const hasAlert = Object.prototype.hasOwnProperty.call(item, "pond_alerted")
        ? !!item.pond_alerted
        : !!(
            item &&
            item.linked_feeders &&
            item.linked_feeders.some(
              (feeder: any) =>
                feeder.alert_battery ||
                feeder.alert_dispenser ||
                feeder.alert_dispenser_opening ||
                feeder.alert_sprinkle ||
                feeder.alert_comm ||
                feeder.alert_reset ||
                feeder.status_dispenser_opening
            )
          );

      return hasAlert ? rojo : verde;
    }

    if (this.default_color && type === "line") {
      return this.default_color;
    }
    if (item) {
      if (is_simple) {
        if (type === "inside") {
          if (item.alerted_feeders || item.alerted_waterwises) {
            return rojo;
          }
        }
        return !item.is_planted ? gris : verde;
      } else if (
        item &&
        item.linked_feeders &&
        item.linked_feeders.length > 0 &&
        type === "inside"
      ) {
        let alerts = item.linked_feeders.some(
          (item) =>
            item.alert_battery ||
            item.alert_comm ||
            item.alert_reset ||
            item.alert_dispenser ||
            item.alert_sprinkle ||
            item.alert_reset
        );
        if (alerts) return rojo;
      }

      return Object.prototype.hasOwnProperty.call(item, "planting") &&
        item.planting &&
        !item.is_done
        ? verde
        : gris;
    }
    return gris;
  }

  validate_color_ponds(linked_feeders) {
    const verde = "#4caf50";
    const rojo = "#FF0000";

    if (linked_feeders && linked_feeders.length > 0) {
      let alerts = linked_feeders.some(
        (item) =>
          item.alert_battery ||
          item.alert_comm ||
          item.alert_reset ||
          item.alert_dispenser ||
          item.alert_sprinkle ||
          item.alert_reset
      );
      if (alerts) return rojo;
    }
    return verde;
  }
  clickPolygon = async (event, value) => {
    this.clickMapPolygon.emit({ event, value });
  };
  centerPolygon(array) {
    return this.globalFunction.centerPolygon(array);
  }
  clickMarker(item) {
    this.clickFeederMap.emit(item);
  }
  mapClick(event) {
    if (this.map_scope) {
      this.pond_selected = null;
      this.show_info_scope = false;
    }
    this.clickMap.emit(event);
  }
  onClickFeederActionAlert(event) {
    this.clickFeederActionAlert.emit(event);
  }
  onClickFeederAction(event) {
    this.clickFeederActionSensor.emit(event);
  }
  dragMarket(event) {
    this.clickFeederMap.emit(event);
  }

  /**
   * Emite la nueva posicion de un marcador del arreglo marker_coordinates.
   * @param event Evento de arrastre emitido por AGM marker.
   * @param index Indice del marcador arrastrado dentro del arreglo.
   */
  onDragMarkerCoordinates(event: any, index: number) {
    if (index < 0) {
      return;
    }

    let lat = null;
    let lng = null;

    if (event && event.coords) {
      lat = event.coords.lat;
      lng = event.coords.lng;
    } else if (event && event.latLng) {
      lat = event.latLng.lat();
      lng = event.latLng.lng();
    }

    if (lat === null || lng === null) {
      return;
    }

    this.dragMarkerCoordinates.emit({ index, lat, lng, event });
  }
  validateColordb(feeder) {
    const { status_power, status_db } = feeder;
    const colors = {
      green: "#008000",
      yellow: "#FFFF00",
      red: "#FF0000"
    };
    if (status_power) {
      if (status_db >= 0 && status_db <= 70) {
        return colors.green;
      }
      if (status_db > 70 && status_db < 90) {
        return colors.yellow;
      }
      return colors.red;
    }
    return colors.red;
  }
  validateIconMarker() {
    let icons = {
      gateway: gateway,
      waterwise: waterwise_icons.sano
    };
    return icons[this.icon_marker] ? icons[this.icon_marker] : this.default_marker_icon;
  }
  onPolygonScopeClick(event, pond) {
    this.pond_selected = pond;
    this.show_info_scope = true;
  }
}
